<template>
  <div>
    <div class="orgs">
      <span>{{ title }}</span>
    </div>
    <vs-table stripe :data="datas">
      <template slot="thead">
        <vs-th style="width:50px">No</vs-th>
        <vs-th class="text-left">Name</vs-th>
        <vs-th class="text-left">Camera Name</vs-th>
        <vs-th class="text-left">IP Address</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-for="(data, i) in datas" :key="i">
          <vs-td :data="i">
            {{ i + 1 }}
          </vs-td>
          <vs-td :data="data.name">
            {{ data.name }}
          </vs-td>
          <vs-td :data="data.camName">
            {{ data.camName }}
          </vs-td>
          <vs-td :data="data.ipAddress">
            {{ data.ipAddress }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  //props: ['title', 'datas', 'next', 'occupancy'],
  props: {
    title: {
      type: String,
      required: true
    },
    datas: {
      type: Array,
      required: true,
    },
    next: {
      type: String,
      required: false
    },
    occupancy: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      breadcrumb: {
        home: {
          title: "Custom Reports",
          link: "/custom_report",
          active: true,
        },
        site: {
          title: "Custom Reports",
          link: "/custom_report",
          active: false,
        },
        area: {
          title: "Custom Reports",
          link: "/custom_report",
          active: false,
        },
        camera: {
          title: "Custom Reports",
          link: "/custom_report",
          active: false,
        }
      }
    }
  },
  methods: {
    goToNextStep(data) {
      const oldBC = localStorage.getItem('reportBreadcrumb')
      let oldBCObj = this.breadcrumb
      if (oldBC != undefined && oldBC != null) {
        oldBCObj = JSON.parse(oldBC)
      }

      oldBCObj.home.active = false;
      oldBCObj.site.active = false;
      oldBCObj.area.active = false;
      oldBCObj.camera.active = false;

      if (this.next.includes("site")) {
        oldBCObj.site = {
          title: data.name,
          link: "/custom_report/site/" + data.id,
          active: true
        }
      }

      if (this.next.includes("area")) {
        oldBCObj.area = {
          title: data.name,
          link: "/custom_report/area/" + data.id,
          active: true
        }
      }

      if (this.next.includes("camera")) {
        oldBCObj.camera = {
          title: data.name,
          link: "/custom_report/camera/" + data.id,
          active: true
        }
      }

      localStorage.setItem('reportBreadcrumb', JSON.stringify(oldBCObj))

      this.$router.push(this.next + '/' + data.id)
    }
  },
  mounted() {
    if (this.$route.name == 'custom_report_view') {
      console.log("masuk home")
      localStorage.setItem('reportBreadcrumb', JSON.stringify(this.breadcrumb))
    }
  }
}
</script>

<style lang="scss" scoped>
.orgs {
  font-size: 32px;

  span {
    color: #1372ac;
    font-weight: 600;
  }

  padding-bottom: 20px;
}

.site-lists {
  .site-item {
    font-weight: 600;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 20px;

    .box-info {
      border: 1px solid #ccc;
      background-color: #eee;
      padding: 5px 10px;
      height: 30px;

      &.inout {
        width: 250px;
        margin-right: 10px;
      }

      &.cam {
        width: 100px;
      }
    }
  }
}
</style>